export const INVALID_ROOM_NAMES = [
  'thanks',
  'invalid-room',
  '__global__'
]
export const WHITEBOARD_BASE_SIZE = {
  width: 1280,
  height: 720
}
